export type DiversityParams = {
    tab: string
    overTime: string
}

export enum Demographics {
    Bespoke = 'bespoke',
    Dimension = 'dimension',
}
